import { render, staticRenderFns } from "./logins.vue?vue&type=template&id=70df0d01&"
import script from "./logins.vue?vue&type=script&lang=js&"
export * from "./logins.vue?vue&type=script&lang=js&"
import style0 from "./logins.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports